import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_HIGH,
  PASTE_COMMAND
} from "lexical";
import {
  $generateNodesFromSerializedNodes,
  $insertGeneratedNodes
} from "@lexical/clipboard";
import { $generateNodesFromDOM } from "@lexical/html";

const PastePlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      (event) => {
        const clipboardData =
          event instanceof ClipboardEvent ? event.clipboardData : null;
        if (!clipboardData) return false;

        const lexicalString = clipboardData.getData(
          "application/x-lexical-editor"
        );
        const htmlString = clipboardData.getData("text/html");
        const plainText = clipboardData.getData("text/plain");

        if (!lexicalString && !htmlString && !plainText) return false;

        event.preventDefault();

        editor.update(() => {
          const selection = $getSelection();
          if (!$isRangeSelection(selection)) return;

          if (lexicalString) {
            try {
              const payload = JSON.parse(lexicalString);
              if (
                payload.namespace === editor._config.namespace &&
                Array.isArray(payload.nodes)
              ) {
                const nodes = $generateNodesFromSerializedNodes(payload.nodes);
                $insertGeneratedNodes(editor, nodes, selection);
                return;
              }
            } catch (err) {
              console.warn("PastePlugin: lexical payload parse failed", err);
            }
          }

          if (htmlString) {
            try {
              const dom = new DOMParser().parseFromString(
                htmlString,
                "text/html"
              );
              const nodes = $generateNodesFromDOM(editor, dom);
              if (nodes.length > 0) {
                $insertGeneratedNodes(editor, nodes, selection);
                return;
              }
            } catch (err) {
              console.warn("PastePlugin: html paste parse failed", err);
            }
          }

          if (plainText) {
            const lines = plainText.split(/\r?\n/);
            for (let i = 0; i < lines.length; i++) {
              selection.insertText(lines[i]);
              if (i < lines.length - 1) {
                selection.insertParagraph();
              }
            }
          }
        });

        return true;
      },
      COMMAND_PRIORITY_HIGH
    );
  }, [editor]);

  return null;
};

export default PastePlugin;
